import React, { useContext } from 'react';

import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ABOUT, CONTACT_US2, CONTACT_SUPPORT, TEAMS_EULA } from '../../constants/urls';
import { DownloadContext } from './context/DownloadContext';

const Container = styled('div')`
    color: ${(props) => props.theme.colors.text.main};
    #footer-links {
        display: flex;
        gap: 48px;
        margin-left: 5%;
        flex: 1;
        font-size: 12px;
        line-height: 12px;
        a {
            font-size: 12px;
        }     
    }
    
    #footer-copyright {
        margin-right: 5%;
        text-align: right;
        flex: 1;
        font-size: 14px;
        line-height: 14px;
    }
    
`;

/* eslint-disable i18next/no-literal-string */

const Footer: React.FC = () => {
    const { t } = useTranslation('class');
    const { isTeamsSchool } = useContext(DownloadContext);

    const year = new Date().getFullYear();
    return (
        <Container>
            <div id="footer-links">
                <a href={ABOUT} target='_blank'>{t('about-2')}</a>
                <a href={CONTACT_SUPPORT} target='_blank'>{t('support-2')}</a>
                <a href={CONTACT_US2} target='_blank'>{t('contact-us-2')}</a>
                {isTeamsSchool && (
                    <a href={TEAMS_EULA} target='_blank'>{t('eula')}</a>
                )}
            </div>
            <div id="footer-copyright">
                © {year} Class Technologies Inc. All rights reserved.
            </div>
        </Container>
    );
};

export default Footer;
